import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import {observer, inject} from 'mobx-react';
import OrderText from './OrderText'


@inject('RootStore')
@observer
export default class OrderStreamBoxedOrder extends Component {
    render() {

        let displayValue = '';
        let pendingCheckin;
        let pendingRefund;
        let order = this.props.RootStore.orderStore.grabSubArrays[this.props.colIndex][this.props.rowIndex];
        let order_status;

        if(order) {
            displayValue = order.display_value;
            pendingCheckin = order.pendingCheckin;
            pendingRefund = order.pendingRefund;
            order_status = order.status !== 'pending_refund' ? order.status : 'queued';
        }

        let boxedOrderDivStyle = {
            margin: "auto",
            color: this.props.RootStore.styleStore.currentStylesDict.boxedOrderFontColor
        };

        let boxedOrderStyle = {
            borderRadius: "3%",
            backgroundColor: order_status? this.props.RootStore.styleStore.currentStylesDict[order_status] : this.props.RootStore.styleStore.currentStylesDict.empty,
        };

        let liveOrderBlock = {
            "fontFamily": "GraphikMedium",
            "border": "thin solid black",
            "marginTop": ".2vmin",
            "justifyContent": "center",
            "letterSpacing": ".05vh",
            "borderRadius": "3%",
            "borderColor": this.props.RootStore.styleStore.currentStylesDict.boxedOrderBorderColor
        };
        return (
            <Flexbox width="100%" flexBasis="9%" flexGrow={1} style={liveOrderBlock}>
                <Flexbox width="100%" height="100%" style={boxedOrderStyle}>
                    <OrderText pendingRefund={pendingRefund} pendingCheckin={pendingCheckin} value={displayValue} style={boxedOrderDivStyle}/>
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/order_stream_widget/live_order_stream_boxed_order.jsx